import type { ReactNode } from 'react';

import { cn } from '@shigo-ui/ui/cn';

export interface DashboardPageFormSecondaryRowProps {
  children: ReactNode;
  actions?: ReactNode | undefined;
  className?: string | undefined;
}

export function DashboardPageFormSecondaryRow({
  children,
  actions,
  className,
}: DashboardPageFormSecondaryRowProps) {
  return (
    <div
      data-slot="dashboard-page-form-secondary-row"
      className={cn(
        'border-border bg-card grid min-w-0 grid-cols-1 items-center gap-x-5 gap-y-3 rounded-md border px-3 py-2.5 min-[360px]:grid-cols-2 sm:flex sm:flex-wrap',
        className,
      )}
    >
      {children}
      {actions !== null && actions !== undefined ? (
        <div
          data-slot="dashboard-page-form-secondary-actions"
          className="col-span-full flex max-w-full min-w-0 flex-wrap items-center gap-2 sm:ml-auto"
        >
          {actions}
        </div>
      ) : null}
    </div>
  );
}
